import generateSlug from '@/utils/generateSlug';
import { v4 } from 'uuid';


export default {
	v4,
	slug: generateSlug,
};
